import React from 'react';
import './Awards.css';

function Awards() {
  const awards = [
    {
      title: 'Above and Beyond Award',
      description: 'Recognized for consistently outstanding performance and exceptional contributions to the team',
      icon: '🏆',
      color: '#fbbf24'
    },
    {
      title: 'You Have Made a Difference Award',
      description: 'Honored for significant contributions to the workplace and positive impact on projects',
      icon: '⭐',
      color: '#34d399'
    }
  ];

  return (
    <section id="awards" className="awards">
      <div className="container">
        <h2 className="section-title reveal">Awards & Recognition</h2>
        <p className="section-subtitle reveal">
          Acknowledgments for going the extra mile
        </p>
        
        <div className="awards-grid">
          {awards.map((award, index) => (
            <div
              key={index}
              className="award-card reveal"
              style={{ '--award-color': award.color }}
            >
              <div className="award-glow" />
              <div className="award-icon">{award.icon}</div>
              <h3 className="award-title">{award.title}</h3>
              <p className="award-description">{award.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Awards;
